import React from 'react';
import AdminDashboardComponent from '../components/AdminDashboard';

const AdminDashboard = () => {
    return <AdminDashboardComponent />;
};

export default AdminDashboard;
